const getWordsFromSentence = ({ sentence, separator="," }) => {
    if(!sentence) return []
    let arrayOfWords = (sentence.toLowerCase()).split(separator);
    arrayOfWords = arrayOfWords.map((word)=> word.trim());
    arrayOfWords = arrayOfWords.filter(word=> !!word)
    return arrayOfWords
}
const getStringFromArray = (value) => {
    if(!value){
        return '';
    }
    if(value && Array.isArray(value)) {
        return value.join(', ')
    }
    return value;
}
const TextOperators = {
    is: {
        id: 'is',
        matcher: (value, matchValue) => {
            value = getStringFromArray(value)
            return value.toLowerCase() === matchValue.toLowerCase()
        }
    },
    is_not: {
        id: 'is_not',
        matcher: (value, matchValue) => {
            if(!value) value = '';
            value = getStringFromArray(value)
            return value.toLowerCase() !== matchValue.toLowerCase()
        }
    },
    starts_with: {
        id: 'starts_with',
        matcher: (value, matchValue) => {
            value = getStringFromArray(value)
            return value.toLowerCase().startsWith(matchValue.toLowerCase())
        }
    },
    ends_with: {
        id: 'ends_with',
        matcher: (value, matchValue) => {
            value = getStringFromArray(value)
            return value.toLowerCase().endsWith(matchValue.toLowerCase())
        }
    },
    contains: {
        id: 'contains',
        matcher: (value, matchValue) => {
            value = getStringFromArray(value)
            let arrayOfWords = getWordsFromSentence({ sentence: matchValue })
            for(let word of arrayOfWords){
                if(value.toLowerCase().includes(word)) {
                    return true;
                }
            }
            return false;
        }
    },
    does_not_contains: {
        id: 'does_not_contains',
        matcher: (value, matchValue) => {
            value = getStringFromArray(value)
            if(!value) value = '';
            let arrayOfWords = getWordsFromSentence({ sentence: matchValue })
            for(let word of arrayOfWords){
                if(value.toLowerCase().includes(word)) {
                    return false;
                }
            }
            return true;
        }
    },
    is_unknown: {
        id: 'is_unknown',
        matcher: (value, _) => {
            value = getStringFromArray(value)
            return value === undefined || value === null || value === ''
        }
    },
    has_any_value: {
        id: 'has_any_value',
        matcher: (value, _) => {
            value = getStringFromArray(value)
            return !(value === undefined || value === null || value === '')
        }
    },
    is_any_of: {
        id: 'is_any_of',
        matcher: (value, matchValue) => {
            let arrayOfWords = getWordsFromSentence({ sentence: matchValue })
            //when the value is array type
            //if no value then none of the give values matches. So no need to match and resolve to false;
            if(value && Array.isArray(value)){
                if(!value.length){
                    return false;
                }
                for(let val of value){
                    if(arrayOfWords.includes(val.toLowerCase())) {
                        return true;
                    }
                }
                return false;
            }
            //for string case
            return arrayOfWords.includes(value.toLowerCase())
        }
    },
    is_none_of: {
        id: 'is_none_of',
        matcher: (value, matchValue) => {
            if(!value) return true;
            let arrayOfWords = getWordsFromSentence({ sentence: matchValue })
            //when the value is array type
            //if no value then none of the give values matches. So no need to match and resolve to false;
            if(value && Array.isArray(value)){
                if(!value.length){
                    return true;
                }
                for(let val of value){
                    if(arrayOfWords.includes(val.toLowerCase())) {
                        return false;
                    }
                }
                return true;
            }
            //for string case
            return !arrayOfWords.includes(value.toLowerCase())
        }
    },
};
module.exports.TextOperators = TextOperators;